import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import {
  useGetProductQuery,
  useRemoveProductMutation,
} from "../../../features/api/productApi";
import { toast } from "react-toastify";
import AddSubItem from "./AddSubItem";
import UpdateSubItem from "./UpdateSubItem";

const SubItem = () => {
  const { data, isLoading } = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const products = data?.data?.filter((d) => d?.sub_catName === 10);

  const [removeProduct] = useRemoveProductMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeProduct(id);

        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = products?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-4">
        <h1 className="text-xl font-bold">Expenses Sub Items</h1>
        <AddSubItem />
      </div>
      <input
        type="text"
        placeholder="Search..."
        className="border focus:outline-none h-10 w-[250px] mb-3 rounded p-1 bg-slate-50"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="py-2">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : products?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no Sub Items
          </p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Main Item</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sub Item</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{row?.subCategory}</TableCell>
                        <TableCell>{row?.product_name}</TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <UpdateSubItem product={row} />
                            {/* <span onClick={() => handleDelete(row?.id)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span> */}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={products?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default SubItem;
